import { dropdownTermTemplate } from "../templates";
var FilterDropdownTerm = Backbone.View.extend({
    tagName: 'button',
    className: 'dropdown-item',
    events: {
        'click' : 'selectTerm'
    },
    initialize: function(){
        _.bindAll( this, 'render', 'selectTerm' );
        this.render();
    },
    render: function(){
        var details = this.model.toJSON();
        window.debugLogger( details );
        var itemHtml = dropdownTermTemplate( details );
        this.el.innerHTML = itemHtml;
    },
    selectTerm : function( e ){
        e.preventDefault();
        var selected = this.model.get( 'selected' );
        this.model.set({'selected': !selected });
    }
});



export {FilterDropdownTerm};